import { defineComponent } from "vue";
export default defineComponent({
    name: "FormPanel",
    props: {
        title: String
    },
    setup: function setup(props, param) {
        var emit = param.emit;
        return {};
    }
});
